module.exports = __webpack_public_path__ + "static/img/product-poster-7.3b684226.png";